import axios from 'axios'

export default {
  name: 'medias',

  ui: {
    popin: '[js-medias-popin]',
    popinClose: '[js-medias-popin-close]',
    popinContent: '[js-medias-popin-content]',
  },

  events: [
    {
      on: 'click',
      target: 'popinClose',
      handle () {
        this.closePopin()
      },
    },
    {
      on: 'click',
      target: 'popin',
      handle (e) {
        if (e.target.closest('[js-medias-popin-content]') === null && !e.target.classList.contains('modal__content')) {
          this.closePopin()
        }
      },
    },
  ],

  componentDidMount () {
    document.body.addEventListener('click', (e) => {
      if (e.target.classList.contains('card-media__inner')) {
        const datas = new FormData()
        datas.append('id', e.target.dataset.id)

        // axios call to get inner content
        const url = config.locale === 'fr' ? '/ajax/render-popin-media' : '/en/ajax/render-popin-media'

        axios.post(url, datas)
          .then(response => {
            this.ui.popinContent.innerHTML = response.data
            this.ui.popin.classList.remove('is-hidden')
          })
          .catch(e => {
            console.log(e)
          })
      }
    })
  },

  closePopin () {
    const iframe = this.ui.popinContent.querySelector('iframe')
    this.ui.popin.classList.add('is-hidden')

    // remove src from iframe to cut video on popin close
    if (iframe) {
      const oldSrc = iframe.getAttribute('src')
      iframe.setAttribute('src', '')

      setTimeout(() => {
        iframe.setAttribute('src', oldSrc)
      }, 600)
    }
  },
}
